import { LoginForm } from '@/components/login-form'

export function LoginPage() {
	return <LoginForm />
}
